import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
const ProtectedRoute: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const {
    user,
    loading
  } = useUser();
  // Show loading state while checking authentication
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen" data-id="element-295">
        <div className="text-center" data-id="element-296">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" data-id="element-297"></div>
          <p className="text-gray-600" data-id="element-298">Loading...</p>
        </div>
      </div>;
  }
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace data-id="element-299" />;
  }
  return <>{children}</>;
};
export default ProtectedRoute;